import React from "react";
import Marquee from "react-fast-marquee";

export default function EditorialMarquee() {
  const items = ["Delivering Water Security", "SWRO", "Brackish (BWRO)", "Developer", "Owner", "Operator"];
  return (
    <div data-testid="marquee" className="bg-brand-navy py-6 md:py-8 border-y border-white/10 overflow-hidden">
      <Marquee speed={55} gradient={false} autoFill>
        {items.map((t, i) => (
          <span key={i} className="flex items-center">
            <span className="font-heading font-extrabold uppercase text-white/90 text-3xl md:text-5xl tracking-tight px-8">
              {t}
            </span>
            <span className="text-brand-teal text-3xl md:text-5xl">—</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
